import React, { useEffect, useState } from 'react';
import { Trans } from '@lingui/react';
import { ModalDialog } from '../../Dialogs';
import { TransButtonDefault, TransButtonPrimaryWithSpinner } from '../../../Atoms/Buttons';
import SelectQuestionnaireTemplate from '../../Event/Questionnaires/SelectQuestionnaireTemplate';
import { Select, Text } from '@mantine/core';
import { IconCalendarEvent, IconChevronDown } from '@tabler/icons';
import { DataS } from '../../../Service/DataS';
import { EventS } from '../../../Service/EventS';

export default function ({ open, toggle, isLoading, finish, provideEventSelect, contactId }) {
  const [template, setTemplate] = useState(undefined);
  const [eventId, setEventId] = useState(undefined);
  const [bookingEvents, setBookingEvents] = useState([]);
  const [loading, setLoading] = useState(false);
  const { length } = bookingEvents;
  const emptyEvents = !loading && length === 0;

  const styles = {
    templateSubject: {
      margin: '15px 0px 5px 0px',
    },
  };

  useEffect(() => {
    if (provideEventSelect) {
      setLoading(true);
      EventS.fetchEventsByCustomerParticipations(contactId)
        .then(setBookingEvents)
        .finally(() => setLoading(false));
    }
  }, [provideEventSelect]);

  return (
    <ModalDialog
      header={<Trans id="template.select.dialog-title" />}
      help="help.questionnaire.template.select"
      body={
        <div>
          <div style={styles.templateSubject}>Vorlage auswählen:</div>
          <SelectQuestionnaireTemplate template={template} onChange={setTemplate} />
          {provideEventSelect && (
            <Select
              label="Event"
              // icon={<IconCalendarEvent size={16} />}
              data={DataS.getEventOptions(bookingEvents)}
              styles={{ rightSection: { pointerEvents: 'none' } }}
              rightSection={<IconChevronDown size={14} />}
              rightSectionWidth={25}
              nothingFound={
                emptyEvents && (
                  <Text>
                    Es wurde kein Event zu diesem Kontakt gefunden. Bitte füge den Kontakt erst einem Event hinzu.
                  </Text>
                )
              }
              value={eventId}
              onChange={(val) => setEventId(val)}
            />
          )}
        </div>
      }
      footer={
        <div>
          <TransButtonDefault onClickHandler={toggle} text="actions.cancel" />{' '}
          <TransButtonPrimaryWithSpinner
            disabled={provideEventSelect && !eventId}
            isLoading={isLoading}
            onClickHandler={() => {
              finish(template, eventId);
            }}
            text="common.apply"
          />
        </div>
      }
      show={open}
      toggle={toggle}
    />
  );
}
